export default __webpack_public_path__ + "static/media/bag256.83f89fe0.png";